/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import ThirdPartyButtons from './thirdPartyButtons'
import ThirdPartyButton from './thirdPartyButton'

export { ThirdPartyButton, ThirdPartyButtons }

export default ThirdPartyButtons
